import { motion } from "motion/react";

export default function Tappable({ children }: { children: React.ReactNode }) {
  return <motion.div whileTap={{ scale: 0.97 }}>{children}</motion.div>;
}
